import { NgModule } from '@angular/core';

import { NgxsModule } from '@ngxs/store';

import { PROJECT_STATE } from './state';
import { ProjectBreadcrumbsState } from './state/breadcrumbs/breadcrumbs.state';

@NgModule({
  imports: [NgxsModule.forFeature(PROJECT_STATE)],
  providers: [ProjectBreadcrumbsState],
})
export class ProjectDataAccessModule {}
